import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';

export const userNeedsRegistration = (registration: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.USER_NEEDS_REGISTRATION,
      payload: registration,
    });
  };
};

export const userNeedsCfeCredentials = (needsCFECredentials: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.USER_NEEDS_CFE_CREDENTIALS,
      payload: needsCFECredentials,
    });
  };
};
export const dontRemindUserCfeCredentials = (
  dontRemindUserCFECredentials: boolean
) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.DONT_REMIND_USER_CFE_CFEDENTIALS,
      payload: dontRemindUserCFECredentials,
    });
  };
};
